<template lang="pug">
div
    .p-a.white.lt.box-shadow
        .row
            .col-md-3.col-sm-4.m-y-sm.pull-right
                dynamic-filter-picker(
                    title="Custom Filter"
                )
                    div(slot="body")
                        override-pricebook-filter

            .col-md-9.col-sm-4.m-y-sm
                h5.m-b-0._300 Station Pricebook

    .padding
        .row
            v-loading.text-center.text-lg(loader="fetch-override-pricebook")

            .col-md-12.m-b-sm(v-if="!onLoading('fetch-override-pricebook')")
                .box
                    v-server-table(
                        ref="datatable"
                        :url="api"
                        :name="tableName"
                        :columns="columns"
                        :options="options"
                    )
                        template(slot="afterFilter", v-if="canCreatePricebook")
                            .box-tool
                                ul.nav
                                    li.nav-item.inline.dropdown
                                        a.nav-link.text-muted.p-x-xs(
                                            data-toggle="dropdown"
                                            aria-expanded="false"
                                        )
                                            i.fa.fa-ellipsis-v
                                        .dropdown-menu.dropdown-menu-scale.pull-right
                                            a.dropdown-item(v-for="a in actionButtons" @click="a.action") {{ a.title }}

                    include aside-modal-override
</template>

<script>
import Auth from '@js/plugins/auth';

const TableName = 'VUETABLE_PRICEBOOK_OVERRIDE';
const STORE_KEY = 'override_pricebook';
import { mapActions, mapGetters, mapState } from 'vuex';
import pricebookModule from '@js/store/modules/override_pricebook';
import OverridePricebookFilter from './override-pricebook-filter';
import DatepickerInput from '@js/components/datepicker/datepicker.vue';
import Feature from '@js/plugins/feature';
import PermissionMixin from './override-permission';
import dynamicFilterPicker from '@js/components/filter/dynamic-filter-picker';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: {
        OverridePricebookFilter,
        DatepickerInput,
        dynamicFilterPicker,
    },

    mixins: [PermissionMixin],

    data: function() {
        var that = this;
        let canManagePricebook = Auth.hasPermissionTo(
            'franchise_manage_station_pricebook',
        );

        let canCreatePricebook = Auth.hasPermissionTo(
            'franchise_create_new_station_pricebook',
        );

        let actionButtons = [
            {
                title: this.trans('station_pricebook.create_override'),
                action: () => {
                    this.$refs.override_modal.$emit('show');
                },
            },
        ];

        if (!canCreatePricebook) {
            actionButtons = [];
        }

        return {
            canCreatePricebook,
            outletList: [],
            outlets_loading: false,
            pricebookList: [],
            pricebook_loading: false,
            tag: {},
            tableName: TableName,
            api: Laroute.route('franchise.inventory.override_pricebook.index'),
            columns: [
                'site_id',
                'outlets',
                'main_pricebook',
                'description',
                'created_at',
                'modified_at',
                'start_at',
            ],
            options: {
                saveState: true,
                checkbox: canManagePricebook,
                checkbox_actions: {
                    api_delete: Laroute.route(
                        'franchise.inventory.override_pricebook.override.delete',
                    ),
                    delete_title: this.trans(
                        'station_pricebook.remove_override',
                    ),
                },
                sortable: ['name'],
                orderBy: { column: 'name', ascending: 1 },
                templates: {
                    outlets(h, row) {
                        return require('../pricebook/outlet.jsx')(h, row);
                    },

                    site_id(h, row) {
                        return require('../pricebook/site_id.jsx')(h, row);
                    },

                    main_pricebook: (h, row) => {
                        return row.base_pricebook.name;
                    },

                    created_at: (h, row) => {
                        return this.formattedDatetime(row.created_at);
                    },

                    modified_at: (h, row) => {
                        return this.formattedDatetime(row.updated_at);
                    },

                    start_at: (h, row) => {
                        return this.formattedDate(row.start_at);
                    },
                },
                headings: {
                    start_at: 'Effective At',
                    main_pricebook: 'Main Pricebook',
                    site_id: 'Site ID',
                    created_at: 'Created At',
                    modified_at: 'Modified At',
                    outlets: Feature.hasFeature('fuel')
                        ? 'Stations'
                        : 'Outlets',
                },
                rowClassCallback: row => 'pointer',
                rowClickCallback: that.showPricebook,
            },
            actionButtons,
        };
    },

    computed: {
        ...mapGetters('override_pricebook', ['pricebookToOverride']),
        ...mapState('override_pricebook', ['filters']),

        fuel_enabled() {
            return Feature.hasFeature('fuel');
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;
            this.setFilter();
        },
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    beforeCreate() {
        this.$store.registerModule(STORE_KEY, pricebookModule);
    },

    created() {
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
    },

    mounted() {
        this.loadOutlets();
    },

    methods: {
        ...mapActions('override_pricebook', ['createPricebookOverride']),

        ...mapActions('pricebook', ['getPricebook', 'setPricebookAttr']),

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },

        formattedDate(date) {
            return moment(date)
                .format('DD MMM YYYY')
                .toUpperCase();
        },

        formattedDatetime(date) {
            return moment(date)
                .format('DD MMM YYYY hh:mm:ss')
                .toUpperCase();
        },

        loadOutlets: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.outlet_pricebook');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.outlets_loading = true;
            this.$http.get(api, options).then(response => {
                this.outletList = response.data.data;
                this.outlets_loading = false;
            });
        }, 500),

        showPricebook(pricebook) {
            window.location.href = Laroute.route(
                'franchise.inventory.override_pricebook.edit',
                { id: pricebook.id },
            );
        },

        showOverridePricebook(override) {
            window.location.href = Laroute.route(
                'franchise.inventory.override_pricebook.edit',
                { id: override.id },
            );
        },

        async submitOverride() {
            this.errors.clear();
            this.hasValidationError = false;

            this.validateField(this.pricebookToOverride.outlets, 'station');
            this.validateField(this.pricebookToOverride.start_at, 'start_at');

            if (!this.validateForm('overrideForm')) return;
            const validate = await this.$validator.validate('override.*');

            if (!validate) return;

            try {
                const override = await this.createPricebookOverride();
                this.showToastrSuccess();
                this.showOverridePricebook(override);
            } catch (e) {
                this.showApiError(e);
            }
        },

        validateField(value, field) {
            if (
                _.isNull(value) ||
                value == '' ||
                value == undefined ||
                value == null ||
                String(value).trim() == ''
            ) {
                if (field == 'start_at') {
                    this.errors.add({
                        field: field,
                        msg: `The effective at field is required`,
                    });
                } else {
                    this.errors.add({
                        field: field,
                        msg: `The ${field} field is required`,
                    });
                }

                this.hasValidationError = true;

                return false;
            }

            return true;
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 20;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }

            if (!_.isNull(query) && !_.isUndefined(query.orderBy)) {
                query.orderBy = { column: 'name', ascending: 1 };

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/override-index.vue